import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useMediaQuery } from '@material-ui/core';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Rating from 'static_pages/marketing_pages/components/TopCaterers/Rating';

const CATERER_LOGO_PLACEHOLDER =
  '/artifacts/images/caterer/placeholder_caterer_logo.webp';

function CatererHeader({ caterer }) {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { t } = useTranslation('caterers');

  return (
    <StyledContainer mobile={mobile}>
      <StyledLeftContainer>
        <StyledCatererName mobile={mobile} component="h1">
          {caterer.name}
        </StyledCatererName>
        <Typography>
          {t('caterer.catererNameLabel', {
            catererName: caterer.name,
          })}
        </Typography>
        {caterer.averageRating && caterer.reviewsCount && (
          <StyledRatingContainer>
            <Rating score={caterer.averageRating * 10} isRated />
            <StyledRatingLabel variant="body1">
              {`${caterer.reviewsCount} ${t('caterer.reviewsCount')}`}
            </StyledRatingLabel>
          </StyledRatingContainer>
        )}
      </StyledLeftContainer>
      <StyledImageWrapper mobile={mobile}>
        <StyledImageContainer mobile={mobile}>
          <Image
            alt=""
            layout="fill"
            priority
            src={caterer.logo || CATERER_LOGO_PLACEHOLDER}
            objectFit="cover"
            objectPosition="center"
          />
        </StyledImageContainer>
      </StyledImageWrapper>
    </StyledContainer>
  );
}

const StyledContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: ${(props) => props.theme.spacing(14)}px;
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
  flex-direction: ${(props) => (props.mobile ? 'column' : 'row')};
  flex-direction: ${(props) => (props.mobile ? 'flex-start' : 'center')};
`;

const StyledLeftContainer = styled(Box)`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  justify-content: center;
`;

const StyledCatererName = styled(Typography)`
  font-size: ${(props) =>
    props.theme.typography[props.mobile ? 'h4' : 'h3'].fontSize};
  font-weight: ${(props) => props.theme.typography.h3.fontWeight};
`;

const StyledRatingContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
  margin-top: ${(props) => props.theme.spacing(1)}px;
`;

const StyledRatingLabel = styled(Typography)`
  font-size: ${(props) => props.theme.typography.body2.fontSize};
`;

const StyledImageWrapper = styled(Box)`
  display: flex;
  flex: 0.5;
  justify-content: ${(props) => (props.mobile ? 'center' : 'flex-end')};
  align-items: center;
`;

const StyledImageContainer = styled(Box)`
  width: ${(props) => (props.mobile ? 340 : 270)}px;
  height: ${(props) => (props.mobile ? 240 : 195)}px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #f0f0f0;
  box-shadow: ${(props) =>
    `${props.mobile ? 'unset' : '0 4px 40px rgba(0, 0, 0, 0.08)'}`};
  border-radius: ${(props) => props.theme.spacing(0.5)}px;
`;

export default CatererHeader;
